var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isMobile ? 'adaptiveMobileClassStyle' : '',attrs:{"id":"app"},on:{"click":_vm.gotnapShare}},[(_vm.allPark)?_c('Nap'):_vm._e(),_vm._v(" "),(_vm.allPark)?_c('div',{staticStyle:{"height":"80px"}}):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.allPark)?_c('Footer'):_vm._e(),_vm._v(" "),_c('chat-dialog',{ref:"chatDialogRef"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-433ced34","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 